import React from "react";
import { Helmet } from "react-helmet-async";
import banner from "../../assets/01_Home/HYUNDAIKONA_17.webp";

/*eslint-disable */

declare const window: any;
const BannerComponent: React.FC = () => {
  return (
    <>
      <Helmet>
        <link rel="preload" as="image" href={banner} fetchPriority="high" />
      </Helmet>
      <div
        className="banner-vehiculos-component"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <h1 className="mascara-banner-vehiculos-component">Vehículos</h1>
      </div>
    </>
  );
};

export default BannerComponent;